// extracted by mini-css-extract-plugin
module.exports = {"Delivery":"delivery_Delivery__hYpvH","DeliveryBaltex":"delivery_DeliveryBaltex__8XyWN","DeliveryLanding":"delivery_DeliveryLanding__Vluvc","Link":"delivery_Link__f4pI9"};